import api from "../api/api";

// GET semua supplier
export const getAllSuppliers = async () => {
  const res = await api.get("/suppliers");
  return res.data.data; // sesuaikan jika struktur respons berbeda
};

// CREATE supplier baru
export const createSupplier = async (payload) => {
  const res = await api.post("/suppliers", payload);
  return res.data;
};

// UPDATE supplier berdasarkan ID
export const updateSupplier = async (id, payload) => {
  const res = await api.put(`/suppliers/${id}`, payload);
  return res.data;
};

// DELETE supplier berdasarkan ID
export const deleteSupplier = async (id) => {
  const res = await api.delete(`/suppliers/${id}`);
  return res.data;
};
